import {Action, Module, Mutation} from 'vuex-module-decorators'
import store, {alertModule} from "@/store";
import BaseModule from "@/store/modules/BaseModule";
import {MdbsCore} from "@/api/tsclient";
import DocumentShortDto = MdbsCore.DocumentShortDto;
import FileParameter = MdbsCore.FileParameter;
import IDocumentUpdateDto = MdbsCore.IDocumentUpdateDto;
import DocumentUpdateDto = MdbsCore.DocumentUpdateDto;
import IDocumentShortDto = MdbsCore.IDocumentShortDto;

const documentClient = new MdbsCore.DocumentClient();

@Module({namespaced: true, name: "document", store: store})
export default class DocumentModule extends BaseModule {
    _documents: Array<DocumentShortDto> = [];

    get documents(): Array<IDocumentShortDto> {
        return this._documents;
    }

    @Mutation
    setDocuments(documents: Array<DocumentShortDto>) {
        this._documents.updateValues(documents);
    }

    @Mutation
    resetDocuments() {
        this._documents.clear();
    }

    @Action({rawError: true})
    async loadAll(includeDeactivated?: boolean) {
        await this.startLoading();
        try {
            const documents = await documentClient.getAll(includeDeactivated);
            this.setDocuments(documents);
        } catch (e) {
            this.resetDocuments();
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action
    async createDocument(payload: {identifier:string, title: string, description: string, order:number, fileParam: FileParameter | null }) {
        this.startLoading();
        try {
            await documentClient.create(payload.identifier, payload.title,  payload.description, payload.order, "{}", payload.fileParam);
            await this.loadAll()
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action
    async download(documentId: string) {
        try {
            return await documentClient.downloadLatestVersion(documentId, true);
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action
    async getDocumentById(documentId: string) {
        try {
            return documentClient.get(documentId)
        } catch (e) {
            await alertModule.handleException(e);
        }
        return null;
    }

    @Action
    async updateDocument(updateDto: IDocumentUpdateDto) {
        this.startLoading();
        try {
            await documentClient.update(updateDto.id, new DocumentUpdateDto(updateDto));
            await this.loadAll()
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action
    async updateDocumentWithContent(payload: {
        id: string,
        title: string,
        order: number,
        identifier: string,
        description: string,
        fileParam: FileParameter | null
    }) {
        this.startLoading();
        try {
            await documentClient.updateWithContent(payload.id, payload.identifier, payload.title, payload.description, payload.order, "{}", payload.fileParam);
            await this.loadAll()
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action
    async deleteDocument(documentId: string) {
        this.startLoading();
        try {
            await documentClient.delete(documentId);
            await this.loadAll()
        } catch (e) {
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }
}
